<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>调剂</el-breadcrumb-item>
        <el-breadcrumb-item>协助调剂</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">协助调剂</h2>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="院校名称"
          prop="college_name"
        >
          <el-select
            v-model="query.college_keyword"
            filterable
            collapse-tags
            placeholder="请选择"
            clearable
            @change="fetchAdjustHelplist(true)"
            @clear="delete_value('college_keyword')"
          >
            <el-option
              v-for="(item, index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="可联系时间段"
          prop="name"
        >
          <el-select
            v-model="query.contact_time_period"
            placeholder="请选择"
            @change="fetchAdjustHelplist(true)"
            clearable
            @clear="delete_value('contact_time_period')"
          >
            <el-option
              label="9:00-12:00"
              value="9:00-12:00"
            ></el-option>
            <el-option
              label="13:00-17:00"
              value="13:00-17:00"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="category_id"
        >
          <el-select
            v-model="query.status"
            placeholder="请选择"
            clearable
            @change="fetchAdjustHelplist(true)"
            @clear="delete_value('status')"
          >
            <el-option
              label="已联系"
              :value="1"
            ></el-option>
            <el-option
              label="未联系"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">调剂列表</h3>
        <el-form
          label-width="70px"
          size="small"
        >
          <el-form-item style="">
            <!--             <el-radio-group v-model="query.status">
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
            width="70"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="contact_name"
            label="姓名"
            align="center"
            width="130"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="contact_mobile"
            label="联系方式"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="first_college_name"
            label="一志愿院校"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="一志愿专业"
            align="center"
            width="210"
          >
            <template slot-scope="scope">
              <span>{{`(${scope.row.first_major_code})${scope.row.first_major_name}`}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="初试总分"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{scope.row.first_score+'分'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="调剂院校"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="调剂专业"
            align="center"
            width="210"
          >
            <template slot-scope="scope">
              <span>{{`(${scope.row.major_code})${scope.row.major_name}`}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="academy_name"
            label="调剂学院"
            align="center"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.academy_name||'无'}}
            </template>
          </el-table-column>
          <!--     <el-table-column prop="academy_name" label="招生类型" align="center" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.enrol_type==1?'全日制':'非全日制'}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="status"
            label="联系状态"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag
                type="success"
                size="small"
                v-if="scope.row.status==1"
              >已联系</el-tag>
              <el-tag
                type="info"
                size="small"
                v-else
              >未联系</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="contact_time_period"
            label="可联系时间段"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.create_time).format("YYYY-MM-DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="操作"
            align="center"
            width="120"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="contact(scope.row)"
                :disabled="scope.row.status==1"
              >联系</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                :underline="false"
                @click="openAssistRecordVisible(scope.row)"
              >调剂记录</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                    v-if="scope.row.status!==1"
                  ><span
                      @click="contact(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      联系
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="openAssistRecordVisible(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      调剂记录
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <AssistRecord
      :visible="AssistRecordVisible"
      @close="AssistRecordVisible=false"
      :id="AssistRecordId"
    />
  </div>
</template>

<script>
import AssistRecord from "@/components/dialog/assist/AssistRecord.vue";
import { adjustHelplist, adjustHelpcontact } from "@/api/adjust";
export default {
  components: {
    AssistRecord
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        isPaging: 1,
        is_user_only: 1,
      },
      pageTotal: 0,
      tableData: [],
      createDatetime: "",
      AssistRecordVisible: false,
      AssistRecordId: null,
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.fetchAdjustHelplist()
  },
  methods: {
    fetchAdjustHelplist(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      adjustHelplist(this.query).then(res => {
        this.tableData = res.list || []
        this.pageTotal = res.count
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchAdjustHelplist();
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.fetchAdjustHelplist();
    },
    contact(item) {
      this.$confirm('确定将状态更改为已联系吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          adjustHelpcontact({ uid: item.uid, status: 1 }).then(res => {
            this.fetchAdjustHelplist()
          })
        })
        .catch(() => {
          this.$notify.error({
            title: "提示",
            message: "已取消操作",
          });
        });
    },
    openAssistRecordVisible(item) {
      this.AssistRecordId = JSON.parse(JSON.stringify(item.uid))
      this.AssistRecordVisible = !this.AssistRecordVisible
    },
    // 接口筛选后端不能接收空值，所以在清除的时候去删掉这个属性
    delete_value(value) {
      this.$delete(this.query, value)
      this.fetchAdjustHelplist()
    },
  }
};
</script>

<style lang="less" scoped>
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-size: 12px;
  }
}
</style>